import { Card, CardContent, Typography, Skeleton } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { PaymentIssueDistribution } from '../../../../types/admin';

interface PaymentIssueDistributionChartProps {
  data: PaymentIssueDistribution[];
  loading?: boolean;
}

export default function PaymentIssueDistributionChart({ data, loading }: PaymentIssueDistributionChartProps) {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Issue Distribution
          </Typography>
          <Skeleton variant="circular" width={300} height={300} sx={{ mx: 'auto' }} />
        </CardContent>
      </Card>
    );
  }

  const chartData = data.map((item, index) => ({
    id: index,
    value: item.count,
    label: item.issue_type.replace('_', ' ').toUpperCase(),
  }));

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Issue Distribution
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Payment issues by type
        </Typography>
        <PieChart
          series={[
            {
              data: chartData,
              highlightScope: { faded: 'global', highlighted: 'item' },
              faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
            },
          ]}
          height={300}
          slotProps={{
            legend: {
              direction: 'column',
              position: { vertical: 'middle', horizontal: 'right' },
              padding: 0,
            },
          }}
        />
      </CardContent>
    </Card>
  );
}
